<template>
    <ClientOnly>
      <Application />
    </ClientOnly>    
</template>